export default {
  'component.portalVersion.guide.title': '新版使用指引',
  'component.portalVersion.guide.start': '開始使用新版',
  'component.portalVersion.guide.classic': '切回經典版',
  'component.portalVersion.guide.intro': '新版調整了選單分組和發布頁面，常用功能可從以下入口找到：',
  'component.portalVersion.guide.release':
    '發布頁面已調整為發布工作台，可切換環境、篩選發布單，並集中查看發布範圍、審批和執行狀態。',
  'component.portalVersion.guide.transition':
    '目前保留新版和經典版是為了過渡，方便大家逐步熟悉新版。',
  'component.portalVersion.guide.workbench': '工作台：我的工作台、審批中心、週報等日常工作。',
  'component.portalVersion.guide.collaboration': '研發協同：需求、迭代、任務和測試等協作事項。',
  'component.portalVersion.guide.delivery': '交付中心：發布工作台、發布日曆、服務檢視和發布記錄。',
  'component.portalVersion.guide.operations': '生產保障：K8s、技術管理、值班表等維運功能。',
  'component.portalVersion.guide.switch':
    '暫時不習慣新版？可隨時透過頁面頂部的「經典版 / 新版」切換入口返回經典版。',
  'component.portalVersion.tip': '切換後會保留當前頁面並刷新選單',
  'component.portalVersion.classic': '經典版',
  'component.portalVersion.v2': '新版',
  'component.tagSelect.expand': '展開',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
};
